// extracted by mini-css-extract-plugin
export default {"card":"interview-home_card__HD3J9"};